import types from '../actionTypes';

export const setActualLanguage = (payload) => ({
  type: types.SET_ACTUAL_LANGUAGE,
  payload: payload,
});

export const resetActualLanguage = () => ({
  type: types.RESET_ACTUAL_LANGUAGE,
});